import {
  Section,
  ReadOnlyField,
  Stack,
} from '@fashionnovateam/nova-ui-toolkit';
import { VendorCatalogItem } from '../../../../Lib/Hooks/ItemService';

type CategoryDetailsSectionProps = {
  item: VendorCatalogItem | undefined;
};

function CategoryDetailsSection({ item }: CategoryDetailsSectionProps) {
  return (
    <Section
      containerClassNames="!items-start !flex-1 !flex-col"
      className="flex-1 !flex !flex-col"
      icon="list/list-search"
      title="Category Details"
      color="yellow"
      iconVariant="solid"
      separateHeader={false}
      withoutShadow
      withoutBorder
      iconColor="black"
      data-testid="category-details-readonly-section"
    >
      <Stack direction="col" className="gap-3">
        <ReadOnlyField
          className="flex-1"
          label="Style Number"
          value={item?.style_number}
          id="style-number"
        />
        <Stack direction="row" className="gap-0.5">
          <ReadOnlyField
            className="flex-1"
            label="Division"
            value={item?.division}
            id="division"
          />
          <ReadOnlyField
            className="flex-1"
            label="Department"
            value={item?.department}
            id="department"
          />
        </Stack>
        <div className="flex flex-row w-full gap-0.5">
          <ReadOnlyField
            className="flex-1"
            label="Category"
            value={item?.category}
            id="category"
          />
          <ReadOnlyField
            className="flex-1"
            label="Class"
            value={item?.class}
            id="class"
          />
        </div>
        <div className="flex flex-row w-full gap-0.5">
          <ReadOnlyField
            className="flex-1"
            label="JR Vendor Reference #"
            value={item?.jr_vendor_ref}
            id="jr-vendor-reference"
          />
          <ReadOnlyField
            className="flex-1"
            label="Plus Vendor Reference #"
            value={item?.plus_vendor_ref}
            id="plus-vendor-reference"
          />
        </div>

        <Stack direction="row" className="flex flex-row w-full gap-0.5">
          <ReadOnlyField
            className="flex-1"
            label="Fashion Nova Exclusive"
            value={item?.fashionnova_exclusive ? 'Yes' : 'No'}
            id="fashionnova-exclusive"
          />
        </Stack>
      </Stack>
    </Section>
  );
}

export default CategoryDetailsSection;
